<template>
  <div class="home" id="home">
    <!-- 头部区域 -->
    <div class="logoBox flex">
      <img src="../../assets/images/newlogo.png" alt="" class="header-logo">
      <!-- <div>
        <span class="text2">AI自主驱动</span>
        <span class="text2">人机协同服务</span>
      </div> -->
    </div>
    <div class="header">
      <span class="text1">智慧人力资源共享服务中心</span>
      <span class="text">智慧人力资源共享服务中心</span>
    </div>
    <div class="topBox">
      <div class="realtime-broadcast flex">
        <div class="broadcast-header">
          <div class="flex aic">
            <span class="live-dot"></span>
            <span class="broadcast-title">实时播报</span>
          </div>
          <div class="broadcast-title-en"> REAL-TIME BROADCAST </div>
        </div>
        <!-- 滚动区域，鼠标悬浮控制滚动 -->
        <div class="scroll-container" @mouseenter="pauseScroll" @mouseleave="resumeScroll">
          <div class="scroll-content" :class="{ paused: isPaused }" :style="{ animationDuration: scrollDuration }">

            <div class="broadcast-item flex" v-for="(item, idx) in broadcasts" :key="idx">
              <div>
                <img src="../../assets/largeIMG/e1.png" class="headerImg" alt="" v-if="item.type==1" />
                <img src="../../assets/largeIMG/e1.png" class="headerImg" alt="" v-if="item.type==2" />
                <img src="../../assets/largeIMG/e1.png" class="headerImg" alt="" v-if="item.type==3" />
                <img src="../../assets/largeIMG/e1.png" class="headerImg" alt="" v-if="item.type==4" />
              </div>
              <div>
                <div>
                  <span v-if="item.type==1" class="aiName jxz">杰小职</span>
                  <span v-if="item.type==2" class="aiName jxx">杰小薪</span>
                  <span v-if="item.type==3" class="aiName jxj">杰小金</span>
                  <span v-if="item.type==4" class="aiName jxa">杰小招</span>
                  完成了
                  <span :class="'action' + item.type">{{ item.action }}</span>
                  <div style="margin-top: 24px;">
                    <span v-if="item.employee"> 员工：{{ item.employee }}</span>
                    <span v-if="item.client"> 客户：{{ item.client }}</span>
                    <span v-if="item.receipt"> 单据：{{ item.receipt }}</span>
                    <span v-if="item.candidate"> 候选人：{{ item.candidate }}</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- 复制 -->
            <div class="broadcast-item flex" v-for="(item, idx) in broadcasts" :key="'copy' + idx">
              <div>
                <img src="../../assets/largeIMG/e1.png" class="headerImg" alt="" v-if="item.type==1" />
                <img src="../../assets/largeIMG/e1.png" class="headerImg" alt="" v-if="item.type==2" />
                <img src="../../assets/largeIMG/e1.png" class="headerImg" alt="" v-if="item.type==3" />
                <img src="../../assets/largeIMG/e1.png" class="headerImg" alt="" v-if="item.type==4" />
              </div>
              <div>
                <div>
                  <span v-if="item.type==1" class="aiName jxz">杰小职</span>
                  <span v-if="item.type==2" class="aiName jxx">杰小薪</span>
                  <span v-if="item.type==3" class="aiName jxj">杰小金</span>
                  <span v-if="item.type==4" class="aiName jxa">杰小招</span>
                  完成了
                  <span :class="'action' + item.type">{{ item.action }}</span>
                  <div style="margin-top: 24px;">
                    <span v-if="item.employee"> 员工：{{ item.employee }}</span>
                    <span v-if="item.client"> 客户：{{ item.client }}</span>
                    <span v-if="item.receipt"> 单据：{{ item.receipt }}</span>
                    <span v-if="item.candidate"> 候选人：{{ item.candidate }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 统计卡片区域 -->
    <div class="stats-grid">
      <div class="stat-card">
        <div class="stat-value">{{ stats.todayPending }}</div>
        <div class="stat-label">今日待办任务总数</div>
      </div>
      <div class="stat-card">
        <div class="stat-value">{{ stats.todayCompleted }}</div>
        <div class="stat-label">今日已办总数量</div>
      </div>
      <div class="stat-card primary">
        <div class="stat-value">{{ stats.jieEmployee }}</div>
        <div class="stat-label">杰小职（员工全职业生命周期服务）完成总数</div>
      </div>
      <div class="stat-card primary">
        <div class="stat-value">{{ stats.jieCustomer }}</div>
        <div class="stat-label">杰小职（客户服务）完成总数</div>
      </div>
      <div class="stat-card primary">
        <div class="stat-value">{{ stats.jieBusiness }}</div>
        <div class="stat-label">杰小职（业务一体化服务）完成总数</div>
      </div>
      <div class="stat-card accent">
        <div class="stat-value">{{ stats.aiMainControl }}%</div>
        <div class="stat-label">AI主控完成</div>
      </div>
      <div class="stat-card">
        <div class="stat-value">{{ stats.humanMachine }} <span class="small-percent">({{ stats.humanMachinePercent }})</span></div>
        <div class="stat-label">人机协同完成</div>
      </div>
      <div class="stat-card">
        <div class="stat-value">{{ stats.aiProcessing }} <span class="small-percent">({{ stats.aiProcessingPercent }})</span></div>
        <div class="stat-label">AI处理占比</div>
      </div>
    </div>

    <!-- 服务流水线区域 -->
    <div class="pipeline-section">
      <div class="pipeline-card">
        <div class="pipeline-title">客户服务<br><span class="sub">服务流水线</span></div>
        <div class="pipeline-items">
          <div class="pipeline-row" v-for="item in customerService" :key="item.name">
            <span class="label">{{ item.name }}</span>
            <span class="value">{{ item.done }} / {{ item.total }}</span>
          </div>
        </div>
      </div>

      <div class="pipeline-card">
        <div class="pipeline-title">员工全生命<br><span class="sub">职业旅程服务</span></div>
        <div class="pipeline-items two-columns">
          <div class="pipeline-row" v-for="item in employeeLifecycle" :key="item.name">
            <span class="label">{{ item.name }}</span>
            <span class="value">{{ item.done }} / {{ item.total }}</span>
          </div>
        </div>
      </div>

      <div class="pipeline-card">
        <div class="pipeline-title">绩效<br><span class="sub">服务流水线</span></div>
        <div class="pipeline-items two-columns">
          <div class="pipeline-row" v-for="item in performanceService" :key="item.name">
            <span class="label">{{ item.name }}</span>
            <span class="value">{{ item.done }} / {{ item.total }}</span>
          </div>
        </div>
      </div>

      <div class="pipeline-card">
        <div class="pipeline-title">业财一体化服务<br><span class="sub">服务流水线</span></div>
        <div class="pipeline-items two-columns">
          <div class="pipeline-row" v-for="item in financeService" :key="item.name">
            <span class="label">{{ item.name }}</span>
            <span class="value">{{ item.done }} / {{ item.total }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 系统状态与实时监控区域 -->
    <div class="system-section">
      <div class="system-status">
        <div class="section-title">系统运行状态 SYSTEM STATUS</div>
        <div class="status-grid">
          <div class="status-item"><span class="label">AI服务可用率</span><span class="value">{{ systemStatus.aiAvailability }}%</span></div>
          <div class="status-item"><span class="label">任务准时率</span><span class="value">{{ systemStatus.taskPunctuality }}%</span></div>
          <div class="status-item"><span class="label">平均处理时长</span><span class="value">{{ systemStatus.avgDuration }}分钟</span></div>
          <div class="status-item"><span class="label">系统吞吐量</span><span class="value">{{ systemStatus.throughput }} 小时</span></div>
          <div class="status-item"><span class="label">数据处理量</span><span class="value">{{ systemStatus.dataVolume }} TB/天</span></div>
          <div class="status-item"><span class="label">知识库更新</span><span class="value">{{ systemStatus.kbUpdates }}条</span></div>
        </div>
      </div>

      <div class="real-time-monitor">
        <div class="section-title">实时任务监控 REAL-TIME TASK MONITORING</div>
        <div class="monitor-grid">
          <div class="monitor-item"><span class="label">智能分发中</span><span class="value">{{ realtimeMonitor.distributing }}</span></div>
          <div class="monitor-item"><span class="label">AI执行中</span><span class="value">{{ realtimeMonitor.aiExecuting }}</span></div>
          <div class="monitor-item"><span class="label">人工监控中</span><span class="value">{{ realtimeMonitor.humanMonitoring }}</span></div>
          <div class="monitor-item"><span class="label">升级干预中</span><span class="value">{{ realtimeMonitor.upgradeIntervening }}</span></div>
        </div>
      </div>
    </div>

    <!-- 任务处理趋势 -->
    <div class="trend-section">
      <div class="section-title">任务处理趋势 (TASK TREND)</div>
      <div class="trend-grid">
        <div class="trend-item" v-for="trend in taskTrends" :key="trend.name">
          <span class="label">{{ trend.name }}</span>
          <span class="value">{{ trend.value }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'AIDashboard',
    data() {
      return {
        scrollDuration: '25s',
        isPaused: false,
        broadcasts: [{
            action: '员工入职登记',
            employee: '张晓明',
            type: 1
          },
          {
            action: '月度薪酬发放',
            client: '上海杰博科技有限公司',
            type: 2
          },
          {
            action: '费用报销审核',
            receipt: 'FYBX/20250520-1024',
            type: 3
          },
          {
            action: '候选人面试安排',
            candidate: '李思远',
            type: 4
          },
          {
            action: '员工社保参保',
            employee: '王小雨',
            type: 1
          }
        ],
        stats: {
          todayPending: 2856,
          todayCompleted: 8742,
          jieEmployee: 3685,
          jieCustomer: 2742,
          jieBusiness: 1368,
          aiMainControl: 92.7,
          humanMachine: 1826,
          humanMachinePercent: '15.7%',
          aiProcessing: 886,
          aiProcessingPercent: '6.9%'
        },
        customerService: [{
            name: '账单',
            done: 23,
            total: 265
          },
          {
            name: '发票',
            done: 18,
            total: 193
          },
          {
            name: '算薪',
            done: 32,
            total: 275
          },
          {
            name: '发薪',
            done: 15,
            total: 186
          },
          {
            name: '月报表',
            done: 9,
            total: 95
          },
          {
            name: '沟通',
            done: 7,
            total: 48
          }
        ],
        employeeLifecycle: [{
            name: '招聘',
            done: 34,
            total: 265
          },
          {
            name: '面试',
            done: 28,
            total: 205
          },
          {
            name: '培训',
            done: 22,
            total: 125
          },
          {
            name: '离职率',
            done: 29,
            total: 216
          },
          {
            name: '人才流失率',
            done: 30,
            total: 236
          },
          {
            name: '电子签约',
            done: 21,
            total: 45
          },
          {
            name: '简历审核',
            done: 26,
            total: 38
          },
          {
            name: '商保续保',
            done: 20,
            total: 38
          },
          {
            name: '社保续保',
            done: 19,
            total: 31
          },
          {
            name: '社保参保',
            done: 28,
            total: 213
          }
        ],
        performanceService: [{
            name: '报销',
            done: 28,
            total: 188
          },
          {
            name: '证明',
            done: 18,
            total: 265
          },
          {
            name: '福利',
            done: 20,
            total: 105
          },
          {
            name: '关怀沟通',
            done: 29,
            total: 87
          },
          {
            name: '工伤报告',
            done: 20,
            total: 68
          },
          {
            name: '离职登记',
            done: 24,
            total: 39
          },
          {
            name: '离职审批',
            done: 26,
            total: 38
          },
          {
            name: '商保减损',
            done: 20,
            total: 38
          },
          {
            name: '社保减损',
            done: 18,
            total: 77
          },
          {
            name: '自需公告',
            done: 19,
            total: 31
          },
          {
            name: '劳动争议',
            done: 16,
            total: 26
          }
        ],
        financeService: [{
            name: '到款',
            done: 12,
            total: 198
          },
          {
            name: '垫资',
            done: 8,
            total: 153
          },
          {
            name: '报销',
            done: 6,
            total: 88
          },
          {
            name: '收入',
            done: 19,
            total: 265
          },
          {
            name: '应收账款',
            done: 22,
            total: 320
          },
          {
            name: '税收',
            done: 18,
            total: 263
          },
          {
            name: '利润报告',
            done: 14,
            total: 159
          }
        ],
        systemStatus: {
          aiAvailability: 99.93,
          taskPunctuality: 98.72,
          avgDuration: 2.47,
          throughput: 12847,
          dataVolume: 1.92,
          kbUpdates: 128
        },
        realtimeMonitor: {
          distributing: 1245,
          aiExecuting: 2154,
          humanMonitoring: 326,
          upgradeIntervening: 48
        },
        taskTrends: [{
            name: '待办任务数',
            value: 0
          },
          {
            name: '已完成任务数',
            value: 0
          },
          {
            name: '税收',
            value: 0
          },
          {
            name: '利润报告',
            value: 0
          },
          {
            name: '应收账龄',
            value: 0
          },
          {
            name: '工资',
            value: 0
          },
          {
            name: '社保',
            value: 0
          },
          {
            name: '公积金',
            value: 0
          },
          {
            name: '其他',
            value: 0
          }
        ]
      }
    },
    created() {
      this.setStyle();
    },
    methods: {
      setStyle() {
        var element = document.getElementById("app");
        element.setAttribute("style", "width: 3440px; height: 1376px;position:absolute;transform-origin: top left;transition: all 0.3s ease-in-out;");
        this.pageSet()
      },
      pageSet() {
        console.log('1')
        // 根据页面自动缩放
        const appdocument = document.getElementById("app");

        function scalePage() {
          // 获取窗口尺寸
          const windowWidth = window.innerWidth;
          const windowHeight = window.innerHeight;

          // 计算缩放比例，以较小的尺寸为基准
          const scale = Math.min(
            windowWidth / originalWidth,
            windowHeight / originalHeight
          );
          // 计算水平和垂直偏移以保持页面居中
          const offsetX = (windowWidth - originalWidth * scale) / 2;
          const offsetY = (windowHeight - originalHeight * scale) / 2;

          // 应用缩放和偏移
          appdocument.style.transform = `scale(${scale})`;
          appdocument.style.transformStyle = "preserve-3d";
          appdocument.style.left = `${offsetX}px`;
          appdocument.style.top = `${offsetY}px`;
        }

        // 初始页面尺寸
        const originalWidth = 3440; // 页面宽度
        const originalHeight = 1376; // 页面高度


        // 初始调用一次
        scalePage();

        // 监听窗口大小变化事件
        window.addEventListener("resize", scalePage);
      },
      pauseScroll() {
        this.isPaused = true;
      },
      resumeScroll() {
        this.isPaused = false;
      }
    }
  }
</script>

<style scoped>
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  .home {
    width: 100%;
    height: 100%;
    background: linear-gradient(135deg, #0a0f1e 0%, #0c1222 100%);
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
    color: #eef2ff;
    position: relative;
    padding: 191px 60px 35px;
  }

  .topBox {
    margin-bottom: 32px;
  }

  .logoBox {
    position: absolute;
    left: 60px;
    /* 距离左边的距离 */
    top: 90px;
    /* 垂直方向 50% */
    transform: translateY(-50%);
    /* 向上回退自身高度的一半，实现垂直居中 */
    height: 120px;
    /* 根据实际 Logo 大小调整 */
    width: auto;
    z-index: 10;
  }

  .text2 {
    font-size: 48px;
  }

  .header-logo {
    height: 120px;
  }

  .header {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 344px;
    background: url("../../assets/images/header.png") no-repeat center;
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
    z-index: 1;
  }

  .header .text1 {
    padding: 0 50px;
    font-family: YouSheBiaoTiHei;
    font-weight: 400;
    font-size: 100px;
    color: #bdf7ec;
    font-style: italic;
    background: linear-gradient(0deg, #ffffff 0%, #abd5e8 41%, #abd5e8 100%);
    -webkit-background-clip: text;
    z-index: 2;
    position: relative;
    -webkit-text-fill-color: transparent;
    letter-spacing: 25px;
  }

  .header .text {
    position: absolute;
    top: 10px;
    transform: translateX(2px);
    padding: 0 50px;
    font-family: YouSheBiaoTiHei;
    font-weight: 400;
    font-size: 100px;
    font-style: italic;
    letter-spacing: 25px;
    color: #4f9bdd;
    z-index: 1;
  }

  .realtime-broadcast {
    background: rgba(18, 25, 45, 0.7);
    backdrop-filter: blur(4px);
    border-radius: 20px;
    padding: 16px 20px;
    border: 1px solid rgba(72, 120, 255, 0.2);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
    overflow: hidden;
    width: 100%;
  }

  .broadcast-header {
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 14px;
    width: 320px;
    padding: 16px 32px 0 0;
    border-right: 1px solid #3A6C91;
  }

  .live-dot {
    width: 24px;
    height: 24px;
    background-color: #3b82f6;
    border-radius: 50%;
    box-shadow: 0 0 24px #3b82f6;
    animation: pulse 1.5s infinite;
    margin: 0 16px;
  }

  .broadcast-title {
    font-size: 48px;
    /* font-weight: 600; */
    color: #9aa9c7;
    letter-spacing: 4px;
    white-space: nowrap;
  }
  .broadcast-title-en{
    font-size: 18px;
    text-align: center;
    letter-spacing: 4px;
    margin-top: 8px;
  }

  .scroll-container {
    width: calc(100% - 340px);
    margin-left: 20px;
    overflow: hidden;
    white-space: nowrap;
    cursor: pointer;
  }

  .scroll-content {
    display: flex;
    animation: scroll-left linear infinite;
    white-space: nowrap;
  }

  /* 暂停滚动 */
  .scroll-content.paused {
    animation-play-state: paused;
  }

  @keyframes scroll-left {
    0% {
      transform: translateX(0);
    }

    100% {
      transform: translateX(-50%);
    }
  }

  .headerImg {
    height: 120px;
    width: auto;
    margin-right: 32px;
  }

  .broadcast-item {
    font-size: 32px;
    color: #cbd5e6;
    background: rgba(59, 130, 246, 0.08);
    padding: 16px 32px;
    margin-right: 32px;
    border-radius: 30px;
    white-space: nowrap;
  }

  /* 统计卡片 */
  .stats-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    gap: 16px;
    margin-bottom: 32px;
  }

  .stat-card {
    background: rgba(15, 23, 42, 0.8);
    backdrop-filter: blur(4px);
    border-radius: 24px;
    padding: 20px 16px;
    text-align: center;
    border: 1px solid rgba(71, 85, 105, 0.4);
    transition: all 0.2s;
  }

  .stat-card.primary {
    background: linear-gradient(145deg, #1e2a4a, #111827);
    border-color: #3b82f6;
  }

  .stat-card.accent {
    background: linear-gradient(145deg, #2a1e3a, #111827);
    border-color: #a855f7;
  }

  .stat-value {
    font-size: 32px;
    font-weight: 800;
    background: linear-gradient(135deg, #fff, #b9c8ff);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
    line-height: 1.2;
  }

  .stat-value .small-percent {
    font-size: 16px;
    font-weight: 500;
    background: none;
    -webkit-background-clip: unset;
    color: #8ba1c4;
  }

  .stat-label {
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: #8ba1c4;
    margin-top: 10px;
    font-weight: 500;
  }

  /* 流水线区域 */
  .pipeline-section {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 24px;
    margin-bottom: 32px;
  }

  .pipeline-card {
    background: rgba(10, 16, 30, 0.7);
    border-radius: 24px;
    padding: 18px 20px;
    border: 1px solid #1f2a44;
  }

  .pipeline-title {
    font-size: 16px;
    font-weight: 700;
    color: #e2e8ff;
    margin-bottom: 16px;
    border-left: 3px solid #3b82f6;
    padding-left: 12px;
  }

  .pipeline-title .sub {
    font-size: 11px;
    font-weight: 400;
    color: #6c7ea0;
  }

  .pipeline-items {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .pipeline-items.two-columns {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 8px 16px;
  }

  .pipeline-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 13px;
    padding: 4px 0;
    border-bottom: 1px dashed rgba(72, 120, 255, 0.15);
  }

  .pipeline-row .label {
    color: #9aaecf;
  }

  .pipeline-row .value {
    color: #facc15;
    font-weight: 600;
  }

  /* 系统状态区域 */
  .system-section {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 24px;
    margin-bottom: 32px;
  }

  .system-status,
  .real-time-monitor {
    background: rgba(10, 16, 30, 0.6);
    border-radius: 24px;
    padding: 18px 24px;
    border: 1px solid #1f2a44;
  }

  .section-title {
    font-size: 14px;
    font-weight: 600;
    color: #b9ceff;
    margin-bottom: 18px;
    letter-spacing: 0.5px;
  }

  .status-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;
  }

  .status-item,
  .monitor-item {
    display: flex;
    flex-direction: column;
  }

  .status-item .label,
  .monitor-item .label {
    font-size: 11px;
    color: #7c8db0;
    margin-bottom: 6px;
  }

  .status-item .value,
  .monitor-item .value {
    font-size: 20px;
    font-weight: 700;
    color: #eef2ff;
  }

  .monitor-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }

  /* 趋势区域 */
  .trend-section {
    background: rgba(10, 16, 30, 0.5);
    border-radius: 24px;
    padding: 18px 24px;
    border: 1px solid #1f2a44;
  }

  .trend-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 16px 32px;
  }

  .trend-item {
    display: flex;
    gap: 12px;
    align-items: baseline;
    font-size: 13px;
  }

  .trend-item .label {
    color: #8ba1c4;
  }

  .trend-item .value {
    font-weight: 700;
    color: #d1dbf0;
  }

  .aiName {
    margin-right: 20px;
    font-weight: 600;
  }

  .jxz {
    color: #DCA7E7;
  }

  .jxj {
    color: #51D0F1;
  }

  .jxx {
    color: #E0AF4F;
  }

  .jxa {
    color: #D49CDB;
  }

  .action1 {
    color: #3D7BCB;
    margin-left: 10px;
    font-weight: 600;
  }

  .action2 {
    color: #5CD9D9;
    margin-left: 10px;
    font-weight: 600;
  }

  .action3 {
    color: #54C993;
    margin-left: 10px;
    font-weight: 600;
  }

  .action4 {
    color: #54C993;
    margin-left: 10px;
    font-weight: 600;
  }

  @keyframes pulse {
    0% {
      opacity: 0.4;
      transform: scale(0.8);
    }

    100% {
      opacity: 1;
      transform: scale(1.2);
    }
  }

  @media (max-width: 860px) {
    .home {
      padding: 16px;
    }

    .system-section {
      grid-template-columns: 1fr;
    }

    .status-grid {
      grid-template-columns: repeat(2, 1fr);
    }
  }
</style>